import { HttpServiceBase } from "../../../common-services/Http/HttpServiceBase";
import { Result } from "../../../common-models/Result";
import { GetErpOrderNFeInput } from "./GetErpOrderNFeInput";
import { GetErpOrderNFeOutput } from "./GetErpOrderNFeOutput";

export class GetErpOrderNFeService extends HttpServiceBase {

  handle = (input: GetErpOrderNFeInput): Promise<Result<GetErpOrderNFeOutput> | null> => {
    const parameters = input ? this.objectToUrl(input) : '';
    const promise = this.http.get<Result<GetErpOrderNFeOutput>>(`${this.baseUrlSislogApi}/v2/order/${input.orderId}/erp-order-nfe${parameters}`);
    return promise;
  }
}